import { render } from "./KycInProcessLabel.vue?vue&type=template&id=7eccd342&scoped=true"
import script from "./KycInProcessLabel.vue?vue&type=script&lang=js"
export * from "./KycInProcessLabel.vue?vue&type=script&lang=js"

import "./KycInProcessLabel.vue?vue&type=style&index=0&id=7eccd342&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eccd342"]])

export default __exports__